import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import { Prompt } from 'react-router';
import { PlusOutlined } from '@ant-design/icons';
import { post } from '../../libs/utils/request';
import ConfirmationDialog from '../common/ConfirmationDialog';
import { user } from '../../libs/utils/user';
import FeedList from '../common/FeedList';
import PostModal from '../NewsFeed/components/PostModal/PostModal';
import TypeSelector from '../NewsFeed/components/TypeSelector';

const styles = {
  root: {
    maxWidth: 1200,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: 80,
    marginBottom: 80,
    paddingRight: 16,
    paddingLeft: 16,
  },
  btnContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row' as const,
    justifyContent: 'center',
  },
  btn: {
    fontWeight: 'bold' as const,
    minWidth: 150,
  },
};

const GroupFeed = ({ groupId }: Props) => {
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [editNews, setEditNews] = useState(null);
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false);
  const [idForDelete, setIdForDelete] = useState(null);
  const [selectedType, setSelectedType] = useState('All');
  const [refreshNeeded, setRefreshNeeded] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-undefined
    window.onbeforeunload = editModalVisible ? () => true : undefined;
    return () => {
      // eslint-disable-next-line no-undefined
      window.onbeforeunload = undefined;
    };
  }, [editModalVisible]);

  const deletePost = async () => {
    if (idForDelete) {
      try {
        await post('/news/delete', { id: idForDelete });
        message.success('Post deleted.');
        setRefreshNeeded(true);
      } catch (error) {
        message.error('Failed to delete post.');
      }
    }
  };

  return (
    <div style={styles.root}>
      <Prompt
        when={editModalVisible}
        message='You have unsaved changes, are you sure you want to leave?'
      />
      {user() && (
        <div style={styles.btnContainer}>
          <Button
            style={styles.btn}
            type='primary'
            size='default'
            onClick={() => {
              setEditNews(null);
              setEditModalVisible(true);
            }}
          >
            <PlusOutlined />
            Create new
          </Button>
        </div>
      )}
      <TypeSelector
        types={['All', 'Post', 'Event', 'Job']}
        value={selectedType}
        onChange={(type: string) => {
          if (type !== 'Event' && type !== 'Job') {
            setSelectedType(type);
          }
        }}
        style={{ marginTop: 16 }}
      />
      <FeedList
        url='news/list'
        selectedType={selectedType}
        refreshNeeded={refreshNeeded}
        setRefreshNeeded={setRefreshNeeded}
        onEdit={(item) => {
          setEditNews(item);
          setEditModalVisible(true);
        }}
        onDelete={(id) => {
          setIdForDelete(id);
          setDeleteDialogVisible(true);
        }}
        groupId={groupId}
        shareDisabled
      />
      <PostModal
        visible={editModalVisible}
        onOk={() => {
          setEditModalVisible(false);
          // setSelectedType(selectedType)
          setRefreshNeeded(true);
        }}
        onCancel={() => setEditModalVisible(false)}
        postUrl='/news/post'
        patchUrl='/news/edit'
        news={editNews}
        group={groupId}
      />
      <ConfirmationDialog
        visible={deleteDialogVisible}
        onCancel={() => setDeleteDialogVisible(false)}
        onOk={() => {
          setDeleteDialogVisible(false);
          deletePost();
        }}
        title='Delete post'
        description='Are you sure you want to delete this post? This operation is not revertible.'
        confirmBtnText='Delete'
        confirmBtnType='danger'
      />
    </div>
  );
};

interface Props {
  groupId: string;
}

export default GroupFeed;
